import React from 'react';
export class Multiselector extends React.Component {
    constructor() {
        super(...arguments);
        this.render = () => {
            const colorStyle = !this.props.disabled
                ? 'hover:border-primary-500 focus:border-primary-600 focus:outline-none focus:shadow-outline-primary-600'
                : '';
            return (React.createElement(React.Fragment, null,
                React.createElement("label", { className: `${this.props.className} block mt-2 text-sm`, style: this.props.style },
                    React.createElement("span", { className: 'text-base-400' }, this.props.label),
                    React.createElement("select", { multiple: true, defaultValue: this.props.defaultValue, value: this.props.value, disabled: this.props.disabled, onChange: this.props.onChange, className: `block mt-1 px-3 py-2 text-sm text-base-300 bg-base-700 border-1 rounded border-base-600 ${colorStyle} transition-colors duration-150` }, this.props.children))));
        };
    }
}
